import {
  FETCHING_PALETTE_IDS_REQUEST, FETCHING_PALETTE_IDS_SUCCEEDED, FETCHING_PALETTE_IDS_FAILED,
  UPDATE_BRANDKIT_ENABLE_TOGGLE_REQUEST, UPDATING_BRANDKIT_ENABLE_TOGGLE_SUCCEEDED, UPDATING_BRANDKIT_ENABLE_TOGGLE_FAILED
} from 'constants/actionTypes.jsx';

import { combineReducers } from 'redux';

import { brandKitMediaReducer } from './mediaReducer';
import { brandKitIconsReducer } from './iconsReducer';
import { brandKitColorsReducer } from './colorsReducer';
import { brandKitTextReducer } from './textReducer';
import { brandKitButtonsReducer } from './buttonReducer';
import { brandKitComponentsReducer } from './componentsReducer';
  
  const initialState = {
    loading: false,
    items: [],
    brandKit: {
      item: null,
      loading: false,
      creating: false,
      updating: false
    }
  }
  
  function activatedBrandKitReducer(state = initialState, action) {
    switch (action.type) {
      case FETCHING_PALETTE_IDS_REQUEST:
        return  {
          ...state,
          loading: true
        }
  
      case FETCHING_PALETTE_IDS_SUCCEEDED:
        var records = action.payload;
  
        return{
          ...state,
          loading: false,
          items: records?.response
        }
  
        case FETCHING_PALETTE_IDS_FAILED:
          return{
            ...state,
            loading: false,
            items: [],
            error: action.payload
          }

          case UPDATE_BRANDKIT_ENABLE_TOGGLE_REQUEST: {
            return {
              ...state,
              loading: true,
              updating: true
            }
          }
            
          case UPDATING_BRANDKIT_ENABLE_TOGGLE_SUCCEEDED: { 
            const {response} = action.payload;
  
            return {
              ...state,
              loading: false,
              updating: false,
            }
          }
            
          case UPDATING_BRANDKIT_ENABLE_TOGGLE_FAILED: {
            return {
              ...state,
              updating: false,
              loading: false,
              error: action.payload.error[0]
            }
          }
  
      default:
        return state
    }
  }


  const brandKitReducer = combineReducers({
    activated: activatedBrandKitReducer,
    media: brandKitMediaReducer,
    icons: brandKitIconsReducer,
    colors: brandKitColorsReducer,
    text: brandKitTextReducer,
    buttons: brandKitButtonsReducer,
    components: brandKitComponentsReducer
  });
  
  export { brandKitReducer };